import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { IconButton } from '../../../icons';
import { IconType } from '../../../icons/Icon';

export default function ImportIconButton(props: ButtonTemplateProps) {
  return (
    <IconButton {...props} text={props.text || t(TranslationKey.import).singular.upper} type={IconType.download1} />
  );
}
